import { gql } from '@apollo/client';
import { IAddressNullable, IBaseEntity, IInsurance } from '@dokucoach/common-types';
import { insuranceBaseData } from './query/insurances';

export type InsuranceListData = {
  id: string;
  deletedAt?: Date | null;
  name: string;
  address?: IAddressNullable | null;
  phoneNumber?: string | null;
  faxNumber?: string | null;
  email?: string | null;
  costObjectNumber: string;
  customCostObjectNumber?: string;
};

export type Insurance = IInsurance & IBaseEntity;

export const GET_INSURANCE_BY_ID = gql`
  query getInsurance($id: ID!){
    getInsurance(id: $id){
      ${insuranceBaseData}
    }
  }
`;

export const GET_ALL_INSURANCES = gql`
  query getInsurances {
    getInsurances {
      ${insuranceBaseData}
    }
  }
`;
